import config from "@/plugins/config.js";
import helperPlugin from "@/plugins/helper.js";

export default {
	install: (app) => {
		app.config.globalProperties.$config = config;
		app.use(helperPlugin);
	},
};
